import React from 'react';

const STATUS_STYLES = {
  active: 'bg-green-100 text-green-800',
  paused: 'bg-yellow-100 text-yellow-800',
  blocked: 'bg-red-100 text-red-800',
  deleted: 'bg-gray-100 text-gray-500',
  error: 'bg-red-100 text-red-800',
};
const STATUS_LABELS = {
  active: 'Aktiv', paused: 'Pausiert', blocked: 'Gesperrt',
  deleted: 'Gelöscht', error: 'Fehler',
};

export default function StatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status] || 'bg-gray-100 text-gray-700'}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
